<footer class="footer py-2 fixed-bottom">
    <div class="container text-center">
      <p>
        <span class="fw-light text-muted">&copy;{{year}} | Brought to you by </span>
        <a href="http://mrpsycho.pl" target="_blank" class="text-decoration-none">Jakub Papuga</a>
        <!-- <span class="fw-light text-muted"> | Abuse: abuse(at)mrpsycho.pl</span> -->
      </p>
    </div>
  </footer>